
const quizContext = {
  quizPaging: {
    recordCount: 0,
    currentPage: 1,
    pageSize: 15 
  },
  quizStandardFiltersCalls: 0,
  quizStandardFilters: {
    standards: [],
    expectations: [],
    indicators: []
  },
  quizTopics: [],
  quizGenerator: {
    questionCount: 0,
    selectedTopics: {}
  },
  quizReviewFrom: undefined,
  quizReviewFromQuery: {},
  quizEditFrom: undefined,
  quizEditFromQuery: {},
  quizPreviewFrom: undefined,
  quizPreviewFromQuery: {},
  quizAssessmentToReview: {},
  quizAssessmentToTake: {},
  quizAssessmentForPdfId: undefined,
  quizAssessmentForPdf: {},
  quizBlankAssessmentForPdfId: undefined,
  quizBlankAssessmentForPdf: {},
  quizAssessmentResults: {},
  quizAssessmentToAssign: false,
  quizAssignmentToModify: false,
  quizAssignmentToReassign: false,
  quizAssessments: [],
  quizAssignments: [],
  quizNewBankQuestion: {},
  quizQuestionBankCart: [],
  quizQuestionBankCartEl: null,
  quizStudentAssessments: [],
  quizStudentAssessmentAssignmentId: undefined,
  quizBankAssessments: [],
  quizQuestionBank: [],
  quizBankQuestionIndex: undefined,
  quizAssessmentToDuplicate: {},
  quizAssessmentCalls: 0,
  quizBankAssessmentCalls: 0,
  quizSearchQuestionBankCalls: 0,
  quizQuestionTemplate: {},
  quizAssignmentCalls: 0,
  quizSelectedDirectory: undefined,
  quizDirectories: {},
  quizBankQuestionToDuplicate: {},
  quizSearch: {
    'assessments': false,
    'assessment-bank': false,
    'question-bank': false,
    'assigned': false,
    'student-assessments': false,
    'assessment': false,
    'assessment-to-review': false,
    'assessment-to-take': false,
    'blank-assessment-for-pdf': false,
    'assessment-for-pdf': false,
    'assessment-results': false
  },
  quizAssessment: {},
  quizSections: [],
  quizQuestions: {},
  quizQuestionStandards: [],
  quizSearchAndSelectSection: undefined,
  quizDialogs: {
    'create-assessment': false,
    'create-directory': false,
    'duplicate-assessment': false,
    'duplicate-bank-question': false,
    'search-and-select-question': false,
    'save-to-bank': false,
    'edit-bank-question': false,
    'edit-assignment': false,
    'edit-student-assignment': false
  },
}

export {quizContext as default}

